import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { TestSuitesLogo } from './-components/TestSuitesLogo';
export const Route = createFileRoute('/_stacktrace/test-suites/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(stacktraceNS);
  const tc = useCommonTranslation();
  useDocumentTitle(t('testSuites.title'));

  /**
   * 現状はリリース前タブのみ実装。それ以外は将来追加予定のため disabled。
   * `to` は LinkProps の型上必須なので未実装パスを `as never` でキャスト。
   */
  const tabs = [{
    to: '/test-suites/overview' as never,
    children: t('testSuites.list.tabs.overview'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-suites',
    children: t('testSuites.list.tabs.beforeRelease'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-suites/released' as never,
    children: t('testSuites.list.tabs.released'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-suites/alerts' as never,
    children: tc('list.alerts'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-suites/operation-activity' as never,
    children: tc('list.operationActivity'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-suites/rules-and-policy' as never,
    children: tc('list.configuration'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-suites/settings' as never,
    children: t('testSuites.list.tabs.settings'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <ProductHeader Logo={TestSuitesLogo} name={t('testSuites.title')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}